import { render } from "./searchableinput.vue?vue&type=template&id=48d4e60e&scoped=true"
import script from "./searchableinput.vue?vue&type=script&lang=js"
export * from "./searchableinput.vue?vue&type=script&lang=js"

import "./searchableinput.vue?vue&type=style&index=0&id=48d4e60e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d4e60e"]])

export default __exports__